import { useMemo } from "react";
import SimpleTable from "../table/SimpleTable";

const check = (value) => (value ? "✔" : "");

const StoresList = ({ stores, setEdit, setEditableStore }) => {
    const columns = useMemo(() => [
        { key: "_id", header: "ID", width: 220 },
        { key: "name", header: "Nome", width: 160 },
        { key: "city", header: "Cidade", width: 120 },
        { key: "state", header: "Estado", width: 90 },
        { key: "active", header: "Ativa", width: 90, format: check, cellClassName: () => "text-green-500" },
        { key: "headquarter", header: "Headquarter", width: 110, format: check, cellClassName: () => "text-green-500" },
        {
            key: "ver", header: "", width: 70, sortable: false, hideable: false, exportable: false,
            cell: ({ row }) => <button type="button" onClick={() => { setEdit(true); setEditableStore(row); }} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Ver</button>,
        },
    ], [setEdit, setEditableStore]);
    return <SimpleTable tableKey="admin-stores" columns={columns} data={stores} />;
};

export default StoresList;
